import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "reservation-admin" }
const _hoisted_2 = { class: "reservation-shell" }
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "date-filter" }
const _hoisted_8 = { class: "filter" }
const _hoisted_9 = { class: "summary-grid" }
const _hoisted_10 = { class: "danger" }
const _hoisted_11 = { class: "content-grid" }
const _hoisted_12 = { class: "table-area" }
const _hoisted_13 = ["onClick", "onDblclick"]
const _hoisted_14 = { class: "mono" }
const _hoisted_15 = { class: "mono" }
const _hoisted_16 = { class: "detail-panel" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "log-list"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "log-list"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_24 = { class: "modal" }
const _hoisted_25 = { class: "modal-tabs" }
const _hoisted_26 = { class: "modal-summary" }
const _hoisted_27 = {
  key: 0,
  class: "modal-body form-layout"
}
const _hoisted_28 = { class: "patient-picker" }
const _hoisted_29 = {
  key: 0,
  class: "patient-results"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "wide treatment-picker" }
const _hoisted_33 = { class: "treatment-options" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "wide" }
const _hoisted_36 = { class: "wide" }
const _hoisted_37 = {
  key: 1,
  class: "modal-body memo-layout"
}
const _hoisted_38 = { class: "memo-input" }
const _hoisted_39 = {
  key: 0,
  class: "log-list"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 2,
  class: "modal-body history-layout"
}
const _hoisted_42 = {
  key: 0,
  class: "log-list"
}
const _hoisted_43 = { key: 1 }

import { computed, reactive, ref } from 'vue';

type ReservationStatus = '예약' | '확인' | '내원' | '완료' | '미이행' | '취소';
type HistoryLog = { id: number; time: string; writer: string; action: string; memo: string };
type PhoneMemo = { id: number; time: string; writer: string; title: string; memo: string };
type Reservation = { id: number; chartNo: string; patient: string; phone: string; date: string; time: string; duration: string; doctor: string; chair: string; category: string; treatment: string; treatmentItems: string[]; status: ReservationStatus; memo: string; smsRule: string; writer: string; changeLogs: HistoryLog[]; phoneMemos: PhoneMemo[] };
type PatientOption = { id?: number; chartNo: string; name: string; phone: string };
type PatientRecord = PatientOption & { gender?: string; birth?: string; email?: string; address?: string; visitPath?: string; guardianName?: string; guardianRelation?: string; guardianPhone?: string; guardianMemo?: string; medicalHistory?: string[]; medications?: string; allergies?: string; memo?: string; privateMemo?: string; status?: string };

const storageKey = 'bioa-reservations';

export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationPage',
  setup(__props) {

const doctors = ['김원장', '박원장', '이실장', '데스크'];
const chairs = ['체어 1', '체어 2', '체어 3', '상담실'];
const statusOptions: ReservationStatus[] = ['예약', '확인', '내원', '완료', '미이행', '취소'];
const treatmentOptions = ['정기검진', '스케일링', '충치 치료', '신경 치료', '발치', '임플란트 상담', '임플란트 수술', '교정 상담', '보철', 'CT/방사선', '구강스캔'];
const timeSlots = Array.from({ length: 26 }, (_, index) => `${String(Math.floor(index / 2) + 9).padStart(2, '0')}:${index % 2 ? '30' : '00'}`);
const todayText = toDateText(new Date());
const reservations = ref<Reservation[]>(loadReservations());
const selectedReservationId = ref<number | null>(reservations.value[0]?.id || null);
const filterText = ref('');
const fromDate = ref('');
const toDate = ref('');
const modalOpen = ref(false);
const isCreating = ref(false);
const modalTab = ref<'basic' | 'memo' | 'history'>('basic');
const editing = reactive<Reservation>(blankReservation());
const patientQuery = ref('');
const patientListOpen = ref(false);
const phoneMemoTitle = ref('');
const phoneMemoBody = ref('');

const selectedReservation = computed(() => reservations.value.find((item) => item.id === selectedReservationId.value) || null);
const selectedLogs = computed(() => selectedReservation.value?.changeLogs || []);
const selectedPhoneMemos = computed(() => selectedReservation.value?.phoneMemos || []);
const todayCount = computed(() => reservations.value.filter((item) => item.date === todayText).length);
const missedCount = computed(() => reservations.value.filter((item) => item.status === '미이행').length);
const patientOptions = computed(() => loadPatientOptions());
const filteredPatients = computed(() => {
  const query = patientQuery.value.trim().toLowerCase();
  if (!query) return patientOptions.value.slice(0, 30);
  return patientOptions.value.filter((item) => [item.name, item.chartNo, item.phone].join(' ').toLowerCase().includes(query)).slice(0, 50);
});
const filteredReservations = computed(() => {
  const query = filterText.value.trim().toLowerCase();
  return reservations.value
    .filter((item) => (!fromDate.value || item.date >= fromDate.value) && (!toDate.value || item.date <= toDate.value))
    .filter((item) => !query || [item.patient, item.chartNo, item.phone, item.doctor, item.chair, item.treatment, item.status, item.memo].join(' ').toLowerCase().includes(query))
    .sort((a, b) => `${b.date} ${b.time}`.localeCompare(`${a.date} ${a.time}`));
});

function createReservation() { isCreating.value = true; Object.assign(editing, blankReservation()); patientQuery.value = ''; phoneMemoTitle.value = ''; phoneMemoBody.value = ''; modalTab.value = 'basic'; modalOpen.value = true; }
function editReservation(reservation: Reservation) { isCreating.value = false; Object.assign(editing, normalizeReservation(clone(reservation))); patientQuery.value = editing.chartNo ? `${editing.patient} ${editing.chartNo}` : editing.patient; phoneMemoTitle.value = ''; phoneMemoBody.value = ''; modalTab.value = 'basic'; modalOpen.value = true; }
function closeModal() { modalOpen.value = false; }
function saveReservation() {
  if (!editing.patient || !editing.date || !editing.time) return;
  if (!ensurePatientForReservation()) return;
  syncTreatmentText();
  const before = selectedReservation.value && !isCreating.value ? clone(selectedReservation.value) : null;
  const memo = before ? diffSummary(before, editing) : `${editing.date} ${editing.time} 예약 생성`;
  editing.changeLogs.unshift(makeLog(isCreating.value ? '예약 최초 입력' : '예약 정보 변경', memo || '세부 정보 저장'));
  if (isCreating.value) { editing.id = Date.now(); reservations.value.unshift(clone(editing)); selectedReservationId.value = editing.id; } else { const index = reservations.value.findIndex((item) => item.id === editing.id); if (index >= 0) reservations.value[index] = clone(editing); }
  saveReservations(); closeModal();
}
function markStatus(status: ReservationStatus) { if (!selectedReservation.value) return; const target = normalizeReservation(clone(selectedReservation.value)); target.status = status; target.changeLogs.unshift(makeLog('예약 상태 변경', `${selectedReservation.value.status} -> ${status}`)); const index = reservations.value.findIndex((item) => item.id === target.id); if (index >= 0) reservations.value[index] = target; saveReservations(); }
function addPhoneMemo() { if (!phoneMemoBody.value.trim()) return; editing.phoneMemos.unshift({ id: Date.now(), time: nowText(), writer: editing.writer || '데스크', title: phoneMemoTitle.value || '전화 메모', memo: phoneMemoBody.value }); editing.changeLogs.unshift(makeLog('전화 메모 추가', phoneMemoTitle.value || '전화 메모')); phoneMemoTitle.value = ''; phoneMemoBody.value = ''; }
function selectPatient(patient: PatientOption) { editing.chartNo = patient.chartNo; editing.patient = patient.name; editing.phone = patient.phone; patientQuery.value = `${patient.name} ${patient.chartNo}`; patientListOpen.value = false; }
function syncTypedPatient() { editing.patient = patientQuery.value; }
function selectFirstPatient() { const first = filteredPatients.value[0]; if (first) selectPatient(first); }
function syncTreatmentText() { editing.treatment = editing.treatmentItems.join(', '); }
function changeCount(reservation: Reservation) { return normalizeReservation(reservation).changeLogs.length; }
function blankReservation(): Reservation { return { id: 0, chartNo: '', patient: '', phone: '', date: todayText, time: '09:00', duration: '30분', doctor: doctors[0], chair: chairs[0], category: '일반 예약', treatment: '', treatmentItems: [], status: '예약', memo: '', smsRule: '1일 전', writer: '데스크', changeLogs: [], phoneMemos: [] }; }
function normalizeReservation(value: Partial<Reservation>): Reservation {
  const treatmentItems = Array.isArray(value.treatmentItems) ? value.treatmentItems : splitTreatment(value.treatment);
  return { ...blankReservation(), ...value, treatmentItems, treatment: value.treatment || treatmentItems.join(', '), duration: value.duration || '30분', category: value.category || '일반 예약', smsRule: value.smsRule || '1일 전', writer: value.writer || '데스크', changeLogs: Array.isArray(value.changeLogs) ? value.changeLogs : [], phoneMemos: Array.isArray(value.phoneMemos) ? value.phoneMemos : [] };
}
function ensurePatientForReservation() {
  const patients = loadPatientRecords();
  const patientName = cleanPatientName(editing.patient || patientQuery.value);
  if (!patientName) return false;
  const chartNo = editing.chartNo.trim();
  const found = patients.find((patient) => chartNo && sameText(patient.chartNo, chartNo)) || patients.find((patient) => sameText(patient.name, patientName) && (!editing.phone || !patient.phone || samePhone(patient.phone, editing.phone)));
  if (found) {
    selectPatient({ id: found.id, chartNo: found.chartNo, name: found.name, phone: found.phone || editing.phone });
    return true;
  }
  const shouldCreate = window.confirm(`${patientName} ${'\uD658\uC790\uB294 \uB4F1\uB85D\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'}\n${'\uD658\uC790 \uB4F1\uB85D \uD6C4 \uC608\uC57D\uC744 \uC800\uC7A5\uD560\uAE4C\uC694?'}\n\n${'\uC5F0\uB77D\uCC98'}: ${editing.phone || '-'}`);
  if (!shouldCreate) return false;
  const patient = makePatientFromReservation(patients, patientName);
  patients.unshift(patient);
  savePatientRecords(patients);
  selectPatient({ id: patient.id, chartNo: patient.chartNo, name: patient.name, phone: patient.phone });
  return true;
}

function makePatientFromReservation(patients: PatientRecord[], patientName: string): PatientRecord {
  return {
    id: Date.now(),
    chartNo: editing.chartNo.trim() || nextPatientChartNo(patients),
    name: patientName,
    phone: editing.phone || '',
    gender: '\uBBF8\uC785\uB825',
    birth: '',
    email: '',
    address: '',
    visitPath: '\uC608\uC57D\uB4F1\uB85D',
    guardianName: '',
    guardianRelation: '',
    guardianPhone: '',
    guardianMemo: '',
    medicalHistory: [],
    medications: '',
    allergies: '',
    memo: '\uC608\uC57D \uB4F1\uB85D \uC911 \uC790\uB3D9 \uC0DD\uC131',
    privateMemo: '',
    status: '\uC815\uC0C1',
  };
}

function loadPatientRecords(): PatientRecord[] {
  try {
    return (JSON.parse(localStorage.getItem('bioa-patients') || '[]') as PatientRecord[]).filter((patient) => patient.name || patient.chartNo);
  } catch {
    return [];
  }
}

function savePatientRecords(patients: PatientRecord[]) { localStorage.setItem('bioa-patients', JSON.stringify(patients)); }
function nextPatientChartNo(patients: PatientRecord[]) { const max = patients.reduce((acc, patient) => Math.max(acc, Number((patient.chartNo || '').replace(/\D/g, '')) || 0), 1000); return `P-${max + 1}`; }
function cleanPatientName(value: string) { return value.trim().replace(/\s+P-\d+.*$/i, '').trim(); }
function sameText(a = '', b = '') { return a.trim().toLowerCase() === b.trim().toLowerCase(); }
function samePhone(a = '', b = '') { return a.replace(/\D/g, '') === b.replace(/\D/g, ''); }
function loadReservations() { try { return (JSON.parse(localStorage.getItem(storageKey) || '[]') as Partial<Reservation>[]).map(normalizeReservation); } catch { return []; } }
function loadPatientOptions(): PatientOption[] { try { return (JSON.parse(localStorage.getItem('bioa-patients') || '[]') as Array<Partial<PatientOption> & { name?: string }>).filter((item) => item.name || item.chartNo).map((item) => ({ id: item.id, chartNo: item.chartNo || `P-${item.id || 'TEMP'}`, name: item.name || '환자', phone: item.phone || '' })); } catch { return []; } }
function saveReservations() { localStorage.setItem(storageKey, JSON.stringify(reservations.value)); }
function makeLog(action: string, memo: string): HistoryLog { return { id: Date.now() + Math.random(), time: nowText(), writer: editing.writer || '데스크', action, memo }; }
function diffSummary(before: Reservation, after: Reservation) {
  const fields: Array<[keyof Reservation, string]> = [['date', '예약일'], ['time', '시간'], ['doctor', '의료진'], ['chair', '체어'], ['status', '상태'], ['treatment', '진료내용'], ['memo', '메모']];
  return fields.filter(([key]) => before[key] !== after[key]).map(([key, label]) => `${label}: ${String(before[key] || '-')} -> ${String(after[key] || '-')}`).join(' / ');
}
function splitTreatment(value: unknown) { return typeof value === 'string' ? value.split(',').map((item) => item.trim()).filter(Boolean) : []; }
function statusClass(status: ReservationStatus) { return { 예약: 'reserved', 확인: 'confirmed', 내원: 'arrived', 완료: 'done', 미이행: 'missed', 취소: 'cancelled' }[status]; }
function nowText() { return new Date().toISOString().slice(0, 16).replace('T', ' '); }
function toDateText(date: Date) { return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`; }
function clone<T>(value: T): T { return JSON.parse(JSON.stringify(value)); }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[42] || (_cache[42] = _createElementVNode("nav", { class: "tabs" }, [
        _createElementVNode("button", { class: "active" }, "예약 입력 변경 이력")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", { onClick: createReservation }, "생성"),
        _createElementVNode("button", {
          disabled: !selectedReservation.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedReservation.value && editReservation(selectedReservation.value)))
        }, "편집", 8, _hoisted_4),
        _createElementVNode("button", {
          disabled: !selectedReservation.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (markStatus('취소')))
        }, "취소", 8, _hoisted_5),
        _createElementVNode("button", {
          disabled: !selectedReservation.value,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (markStatus('완료')))
        }, "완료", 8, _hoisted_6),
        _createElementVNode("label", _hoisted_7, [
          _cache[27] || (_cache[27] = _createElementVNode("span", null, "기간", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fromDate).value = $event)),
            type: "date"
          }, null, 512), [
            [_vModelText, fromDate.value]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((toDate).value = $event)),
            type: "date"
          }, null, 512), [
            [_vModelText, toDate.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_8, [
          _cache[28] || (_cache[28] = _createElementVNode("span", null, "필터", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterText).value = $event)),
            placeholder: "환자/차트/연락처/진료/메모 검색"
          }, null, 512), [
            [_vModelText, filterText.value]
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("article", null, [
          _cache[29] || (_cache[29] = _createElementVNode("span", null, "전체 예약", -1)),
          _createElementVNode("strong", null, _toDisplayString(filteredReservations.value.length) + "건", 1)
        ]),
        _createElementVNode("article", null, [
          _cache[30] || (_cache[30] = _createElementVNode("span", null, "오늘 예약", -1)),
          _createElementVNode("strong", null, _toDisplayString(todayCount.value) + "건", 1)
        ]),
        _createElementVNode("article", null, [
          _cache[31] || (_cache[31] = _createElementVNode("span", null, "미이행", -1)),
          _createElementVNode("strong", _hoisted_10, _toDisplayString(missedCount.value) + "건", 1)
        ]),
        _createElementVNode("article", null, [
          _cache[32] || (_cache[32] = _createElementVNode("span", null, "캘린더 연동", -1)),
          _createElementVNode("strong", null, _toDisplayString(reservations.value.length) + "건", 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("section", _hoisted_12, [
          _createElementVNode("table", null, [
            _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "예약일시"),
                _createElementVNode("th", null, "환자"),
                _createElementVNode("th", null, "차트번호"),
                _createElementVNode("th", null, "연락처"),
                _createElementVNode("th", null, "진료내용"),
                _createElementVNode("th", null, "의료진"),
                _createElementVNode("th", null, "체어"),
                _createElementVNode("th", null, "상태"),
                _createElementVNode("th", null, "변경")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReservations.value, (reservation) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: reservation.id,
                  class: _normalizeClass({ selected: selectedReservationId.value === reservation.id }),
                  onClick: ($event: any) => (selectedReservationId.value = reservation.id),
                  onDblclick: ($event: any) => (editReservation(reservation))
                }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(reservation.date) + " " + _toDisplayString(reservation.time), 1),
                  _createElementVNode("td", null, _toDisplayString(reservation.patient), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(reservation.chartNo || '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(reservation.phone || '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(reservation.treatment || '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(reservation.doctor), 1),
                  _createElementVNode("td", null, _toDisplayString(reservation.chair), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status", statusClass(reservation.status)])
                    }, _toDisplayString(reservation.status), 3)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(changeCount(reservation)) + "회", 1)
                ], 42, _hoisted_13))
              }), 128))
            ])
          ]),
          _createElementVNode("footer", null, _toDisplayString(filteredReservations.value.length) + "개 항목", 1)
        ]),
        _createElementVNode("aside", _hoisted_16, [
          _createElementVNode("section", null, [
            _cache[39] || (_cache[39] = _createElementVNode("header", null, "선택 예약", -1)),
            (selectedReservation.value)
              ? (_openBlock(), _createElementBlock("dl", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _cache[34] || (_cache[34] = _createElementVNode("dt", null, "환자", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedReservation.value.patient) + " / " + _toDisplayString(selectedReservation.value.chartNo || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[35] || (_cache[35] = _createElementVNode("dt", null, "예약", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedReservation.value.date) + " " + _toDisplayString(selectedReservation.value.time), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("dt", null, "담당", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedReservation.value.doctor) + " · " + _toDisplayString(selectedReservation.value.chair), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[37] || (_cache[37] = _createElementVNode("dt", null, "상태", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedReservation.value.status), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("dt", null, "메모", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedReservation.value.memo || '-'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_18, "목록에서 예약을 선택하세요."))
          ]),
          _createElementVNode("section", null, [
            _cache[40] || (_cache[40] = _createElementVNode("header", null, "변경 이력", -1)),
            (selectedLogs.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLogs.value, (log) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: log.id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(log.time) + " · " + _toDisplayString(log.writer), 1),
                      _createElementVNode("strong", null, _toDisplayString(log.action), 1),
                      _createElementVNode("p", null, _toDisplayString(log.memo), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_20, "변경 이력이 없습니다."))
          ]),
          _createElementVNode("section", null, [
            _cache[41] || (_cache[41] = _createElementVNode("header", null, "전화 메모", -1)),
            (selectedPhoneMemos.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPhoneMemos.value, (memo) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: memo.id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(memo.time) + " · " + _toDisplayString(memo.writer), 1),
                      _createElementVNode("strong", null, _toDisplayString(memo.title), 1),
                      _createElementVNode("p", null, _toDisplayString(memo.memo), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_22, "전화 메모가 없습니다."))
          ])
        ])
      ])
    ]),
    (modalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("section", _hoisted_24, [
            _createElementVNode("header", null, [
              _createElementVNode("strong", null, _toDisplayString(isCreating.value ? '예약 생성' : '예약 상세 편집'), 1),
              _createElementVNode("button", { onClick: closeModal }, "×")
            ]),
            _createElementVNode("nav", _hoisted_25, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: modalTab.value === 'basic' }),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (modalTab.value = 'basic'))
              }, "예약 정보", 2),
              _createElementVNode("button", {
                class: _normalizeClass({ active: modalTab.value === 'memo' }),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (modalTab.value = 'memo'))
              }, "전화 메모", 2),
              _createElementVNode("button", {
                class: _normalizeClass({ active: modalTab.value === 'history' }),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (modalTab.value = 'history'))
              }, "변경 이력", 2)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", null, [
                _cache[43] || (_cache[43] = _createElementVNode("span", null, "환자", -1)),
                _createElementVNode("strong", null, _toDisplayString(editing.patient || '미입력'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("span", null, "차트번호", -1)),
                _createElementVNode("strong", null, _toDisplayString(editing.chartNo || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[45] || (_cache[45] = _createElementVNode("span", null, "예약", -1)),
                _createElementVNode("strong", null, _toDisplayString(editing.date) + " " + _toDisplayString(editing.time), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[46] || (_cache[46] = _createElementVNode("span", null, "상태", -1)),
                _createElementVNode("strong", null, _toDisplayString(editing.status), 1)
              ])
            ]),
            (modalTab.value === 'basic')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, [
                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "field-label" }, [
                      _createTextVNode("환자 "),
                      _createElementVNode("em", null, "*")
                    ], -1)),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((patientQuery).value = $event)),
                        placeholder: "이름/차트/전화 검색 또는 직접 입력",
                        onFocus: _cache[10] || (_cache[10] = ($event: any) => (patientListOpen.value = true)),
                        onInput: syncTypedPatient,
                        onKeyup: _withKeys(selectFirstPatient, ["enter"])
                      }, null, 544), [
                        [_vModelText, patientQuery.value]
                      ]),
                      (patientListOpen.value && patientQuery.value.trim())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPatients.value, (patient) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: patient.chartNo,
                                type: "button",
                                onClick: ($event: any) => (selectPatient(patient))
                              }, [
                                _createElementVNode("strong", null, _toDisplayString(patient.name), 1),
                                _createElementVNode("span", null, _toDisplayString(patient.chartNo) + " · " + _toDisplayString(patient.phone || '-'), 1)
                              ], 8, _hoisted_30))
                            }), 128)),
                            (!filteredPatients.value.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_31, "등록된 환자가 없습니다. 직접 입력해도 됩니다."))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[48] || (_cache[48] = _createElementVNode("span", { class: "field-label" }, "차트번호", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editing.chartNo) = $event)),
                      placeholder: "P-0001"
                    }, null, 512), [
                      [_vModelText, editing.chartNo]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "field-label" }, "연락처", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editing.phone) = $event)),
                      placeholder: "010-0000-0000"
                    }, null, 512), [
                      [_vModelText, editing.phone]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "field-label" }, [
                      _createTextVNode("예약일 "),
                      _createElementVNode("em", null, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editing.date) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, editing.date]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "field-label" }, [
                      _createTextVNode("예약시간 "),
                      _createElementVNode("em", null, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editing.time) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeSlots), (time) => {
                        return (_openBlock(), _createElementBlock("option", { key: time }, _toDisplayString(time), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, editing.time]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[53] || (_cache[53] = _createElementVNode("span", { class: "field-label" }, "소요시간", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editing.duration) = $event))
                    }, _cache[52] || (_cache[52] = [
                      _createElementVNode("option", null, "15분", -1),
                      _createElementVNode("option", null, "30분", -1),
                      _createElementVNode("option", null, "45분", -1),
                      _createElementVNode("option", null, "1시간", -1),
                      _createElementVNode("option", null, "1시간 30분", -1)
                    ]), 512), [
                      [_vModelSelect, editing.duration]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("span", { class: "field-label" }, "의료진", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editing.doctor) = $event))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(doctors, (doctor) => {
                        return _createElementVNode("option", { key: doctor }, _toDisplayString(doctor), 1)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, editing.doctor]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[55] || (_cache[55] = _createElementVNode("span", { class: "field-label" }, "체어", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editing.chair) = $event))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chairs, (chair) => {
                        return _createElementVNode("option", { key: chair }, _toDisplayString(chair), 1)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, editing.chair]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[57] || (_cache[57] = _createElementVNode("span", { class: "field-label" }, "예약구분", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editing.category) = $event))
                    }, _cache[56] || (_cache[56] = [
                      _createElementVNode("option", null, "일반 예약", -1),
                      _createElementVNode("option", null, "정기 검진", -1),
                      _createElementVNode("option", null, "상담", -1),
                      _createElementVNode("option", null, "수술", -1),
                      _createElementVNode("option", null, "응급", -1)
                    ]), 512), [
                      [_vModelSelect, editing.category]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[58] || (_cache[58] = _createElementVNode("span", { class: "field-label" }, "상태", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((editing.status) = $event))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                        return _createElementVNode("option", { key: status }, _toDisplayString(status), 1)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, editing.status]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_32, [
                    _cache[59] || (_cache[59] = _createElementVNode("span", { class: "field-label" }, "진료항목", -1)),
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(treatmentOptions, (item) => {
                        return _createElementVNode("label", { key: item }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editing.treatmentItems) = $event)),
                            type: "checkbox",
                            value: item,
                            onChange: syncTreatmentText
                          }, null, 40, _hoisted_34), [
                            [_vModelCheckbox, editing.treatmentItems]
                          ]),
                          _createTextVNode(_toDisplayString(item), 1)
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_35, [
                    _cache[60] || (_cache[60] = _createElementVNode("span", { class: "field-label" }, "진료내용", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((editing.treatment) = $event)),
                      placeholder: "체크 항목 외 추가 내용 입력"
                    }, null, 512), [
                      [_vModelText, editing.treatment]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_36, [
                    _cache[61] || (_cache[61] = _createElementVNode("span", { class: "field-label" }, "예약 메모", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((editing.memo) = $event)),
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, editing.memo]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[63] || (_cache[63] = _createElementVNode("span", { class: "field-label" }, "문자 알림", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((editing.smsRule) = $event))
                    }, _cache[62] || (_cache[62] = [
                      _createElementVNode("option", null, "발송 안 함", -1),
                      _createElementVNode("option", null, "예약 즉시", -1),
                      _createElementVNode("option", null, "1일 전", -1),
                      _createElementVNode("option", null, "3시간 전", -1),
                      _createElementVNode("option", null, "1시간 전", -1)
                    ]), 512), [
                      [_vModelSelect, editing.smsRule]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("span", { class: "field-label" }, "작성자", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editing.writer) = $event)),
                      placeholder: "데스크"
                    }, null, 512), [
                      [_vModelText, editing.writer]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (modalTab.value === 'memo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("section", _hoisted_38, [
                    _cache[67] || (_cache[67] = _createElementVNode("header", null, "전화 메모 추가", -1)),
                    _createElementVNode("label", null, [
                      _cache[65] || (_cache[65] = _createElementVNode("span", { class: "field-label" }, "제목", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((phoneMemoTitle).value = $event)),
                        placeholder: "예약 확인 통화"
                      }, null, 512), [
                        [_vModelText, phoneMemoTitle.value]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[66] || (_cache[66] = _createElementVNode("span", { class: "field-label" }, "메모", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((phoneMemoBody).value = $event)),
                        rows: "5"
                      }, null, 512), [
                        [_vModelText, phoneMemoBody.value]
                      ])
                    ]),
                    _createElementVNode("button", { onClick: addPhoneMemo }, "메모 추가")
                  ]),
                  _createElementVNode("section", null, [
                    _cache[68] || (_cache[68] = _createElementVNode("header", null, "전화 메모 목록", -1)),
                    (editing.phoneMemos.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editing.phoneMemos, (memo) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: memo.id
                            }, [
                              _createElementVNode("span", null, _toDisplayString(memo.time) + " · " + _toDisplayString(memo.writer), 1),
                              _createElementVNode("strong", null, _toDisplayString(memo.title), 1),
                              _createElementVNode("p", null, _toDisplayString(memo.memo), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_40, "전화 메모가 없습니다."))
                  ])
                ]))
              : _createCommentVNode("", true),
            (modalTab.value === 'history')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (editing.changeLogs.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editing.changeLogs, (log) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: log.id
                          }, [
                            _createElementVNode("span", null, _toDisplayString(log.time) + " · " + _toDisplayString(log.writer), 1),
                            _createElementVNode("strong", null, _toDisplayString(log.action), 1),
                            _createElementVNode("p", null, _toDisplayString(log.memo), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_43, "저장하면 변경 이력이 생성됩니다."))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("footer", null, [
              _createElementVNode("button", {
                class: "ghost",
                onClick: closeModal
              }, "취소"),
              _createElementVNode("button", {
                class: "primary",
                onClick: saveReservation
              }, "저장")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})